import createApp from '@shopify/app-bridge';
import { getSessionToken } from '@shopify/app-bridge/utilities';

let appPromise;

async function getAppBridge() {
  const params = new URLSearchParams(window.location.search);
  const host = params.get('host');
  if (!host) return null;

  if (!appPromise) {
    appPromise = fetch('/api/config', { credentials: 'include' })
      .then(async (response) => {
        if (!response.ok) throw new Error('Unable to load Shopify app configuration');
        const config = await response.json();
        if (!config.shopifyApiKey) throw new Error('Shopify API key is not configured');
        return createApp({
          apiKey: config.shopifyApiKey,
          host,
          forceRedirect: true
        });
      });
  }
  return appPromise;
}

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export async function apiFetch(url, options = {}) {
  const headers = new Headers(options.headers || {});
  const app = await getAppBridge();
  if (app) {
    headers.set('Authorization', `Bearer ${await getSessionToken(app)}`);
  }

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include'
  });
  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const message = typeof data === 'object'
      ? (data.error || data.message || `Request failed (${response.status})`)
      : (data || `Request failed (${response.status})`);
    throw new ApiError(message, response.status, data);
  }
  return data;
}
